export default {"src":"/_next/static/media/currency-symbol.93913150.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};